import {
    Card,
    CardContent,
    Grid,
    Box,
    TextField,
    useMediaQuery
} from "@mui/material";
import Tabs from "../tabs";
import { useState, useEffect } from "react";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../../components/buttons/customButton";
import { addCategoryThunk, getCategoriesThunk } from "../../filesThunk";
import { APP_ROUTES } from "../../../../config/appRoutes";
import { useNavigate } from "react-router-dom";

export default function CategoryCreation() {
    const isMobile = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { status, error } = useSelector((state) => state.fileCategories);

    const [categoryName, setCategoryName] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!categoryName.trim()) {
            setSnackbar({
                open: true,
                message: "Category Name is required",
                severity: "error",
            });
            return;
        }

        try {
             const result = await dispatch(
                addCategoryThunk({ credentials: { category_name: categoryName.trim() } })
            );

            if (result.meta.requestStatus === "fulfilled") {
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });
                dispatch(getCategoriesThunk({ type: "getCategory" }));

                navigate(APP_ROUTES.CATEGORY.LIST);
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    useEffect(() => {
        if (error !== null) {
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    }, [error]);

    return (
        <div>
            <Tabs />

            <Box mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, md: 4 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Category Name"
                                    name="categoryName"
                                    value={categoryName}
                                    inputProps={{ maxLength: 20 }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value.startsWith(" ")) return;
                                        setCategoryName(value);
                                    }}
                                    error={!categoryName.trim() && snackbar.severity === "error"}
                                    helperText={false}
                                />
                            </Grid>

                            <Grid
                                item
                                size={{ xs: 12, md: 4 }}
                                sx={{
                                    display: "flex",
                                    justifyContent: isMobile ? "flex-start" : "flex-end",
                                }}
                            >
                                <CustomButton
                                    status={status}
                                    onClick={handleSubmit}
                                    label="Create Category"
                                    loadingLabel="Submitting.."
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </div>
    );
}
